import { render, staticRenderFns } from "./FiscalFormProdutos.vue?vue&type=template&id=0dab880e&scoped=true"
import script from "./FiscalFormProdutos.vue?vue&type=script&lang=js"
export * from "./FiscalFormProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dab880e",
  null
  
)

export default component.exports